{
  "cms.catalog.action.createOption.banner": "Banner",
  "cms.catalog.group.banner": "Banners",
  "cms.create.banner.heading": "New banner",
  "cms.create.banner.categoryMissing": "Content category \"jasenyys\" was not found. A banner cannot be created until the category exists.",
  "cms.form.banner.section.content": "Banner content",
  "cms.form.banner.title": "Upper line",
  "cms.form.banner.subtitle": "Lower line",
  "cms.form.banner.color": "Colour",
  "cms.form.banner.color.green": "Green",
  "cms.form.banner.color.navy": "Dark blue",
  "cms.form.banner.color.red": "Red",
  "cms.form.banner.dismissible": "Close button visible",
  "cms.form.banner.dismissible.help": "The user can close the banner.",
  "cms.form.banner.scope": "Visibility",
  "cms.form.banner.scope.home": "Show on the home page only",
  "cms.form.banner.scope.sitewide": "Show everywhere",
  "cms.form.banner.error.titleRequired": "The upper line is required (at most 120 characters).",
  "cms.form.banner.error.titleNotDerivable": "The upper line must contain at least one Latin letter or digit.",
  "cms.form.banner.error.subtitleTooLong": "The lower line may be at most 120 characters.",
  "cms.form.banner.singletonRefused": "This language already has a published banner: {title}. Unpublish or replace it before publishing.",
  "cms.form.banner.singletonRefused.unnamed": "This language already has a published banner. Unpublish or replace it before publishing."
}
